// extracted by mini-css-extract-plugin
export default {"wrapper":"EleganteParis_wrapper__s0mxb"};